module.exports = __webpack_public_path__ + "static/img/icon@2x.389f48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb/icon@2x.png
// module id = PLm9
// module chunks = 70